<div class="container-with-loader">
  <div *ngIf="showLoadingOverlay" class="loading-overlay">
    <div class="spinner"></div>
    <p>Loading Itinerary...</p>
  </div>
  <div class="container">
    <div class="itinerary-panel">
      <route-itinerary
        [routeId]="routeRecommendationId"
        [fullWidth]="true"
        [routeGrabbed]="true"
        (itineraryLoaded)="itineraryLoading = false"
      ></route-itinerary>
    </div>
    <div class="map-panel">
      <map-control-v2
        [routeId]="routeRecommendationId"
        [displayTaskLegends]="true"
        [(selectedTaskId)]="selectedTaskId"
        (mapLoaded)="mapLoading = false"
      ></map-control-v2>
    </div>
  </div>
</div>
